import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';

import Wrapper from '../elements/wrapper';
import { media } from '../helpers';
import Wave from '../../images/waves/home-top-wave.inline.svg';

const CollectionContentRowsContainer = styled.div`
    background-color: #f2f0eb;
    padding-bottom: 100px;
    top: -10vh;
    position: relative;
    margin-bottom: -10vh;
    .svg-container {
        background-color: #f2f0eb;
        svg {
            width: 100%;
            height: auto;
            path {
                opacity: 1;
                fill: #fff;
            }
        }
    }

    .extended-description {
        text-align: center;
        padding: 40px 0;
        ${media.medium`max-width: 650px;padding: 0 0 40px;`}

        h3 {
            margin: 0 0 20px;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            color: #000;
            font-size: 2rem;
            ${media.medium`font-size: 2.6rem;`}
        }

        p {
            font-size: 0.9rem;
        }
    }

    .content-row-wrapper {
        margin-bottom: 40px;
        ${media.xsmall`max-width: 450px;`}
        ${media.large`display: flex; max-width: 70vw; margin-bottom: 70px;`}

        &.flipped {
            .image-container {
                order: 2;
            }
            .content-container {
                order: 1;
            }
        }

        &:last-child {
            margin-bottom: 0px;
        }

        .image-container {
            flex: 1;
        }
        .content-container {
            flex: 1;
            display: flex;
            align-items: center;
            padding: 30px 20px 0;

            .inner-wrap {
                max-width: 450px;
                margin: 0 auto;

                h3 {
                    font-family: neue-kabel, sans-serif;
                    color: #000;
                    margin: 0 0 15px;
                    line-height: 1;
                    font-weight: 800;
                    font-size: 2rem;
                    ${media.medium`font-size: 2.6rem;`}
                }

                p {
                    font-size: 1.1rem;
                    line-height: 1.5;
                }
            }
        }
    }
`;

const CollectionContentRows = ({ collectionContentRowSettings }) => {
    const {
        collectionDescriptionTitle,
        collectionDescription,
        collectionContentRows,
    } = collectionContentRowSettings || {};

    function generateDescription() {
        return { __html: collectionDescription };
    }

    function isOdd(num) {
        return num % 2;
    }

    return (
        <CollectionContentRowsContainer>
            <div className="svg-container">
                <Wave />
            </div>
            <Wrapper className="extended-description">
                <h3>{collectionDescriptionTitle}</h3>
                <div
                    className="content"
                    dangerouslySetInnerHTML={generateDescription()}
                ></div>
            </Wrapper>
            {collectionContentRows &&
                collectionContentRows.map((row, index) => {
                    const {
                        contentRowImage,
                        contentRowTitle,
                        contentRowDescription,
                    } = row || {};

                    let isProductOdd = isOdd(index);

                    return (
                        <Wrapper
                            className={
                                !isProductOdd
                                    ? 'content-row-wrapper flipped'
                                    : 'content-row-wrapper'
                            }
                        >
                            <div className="image-container">
                                <Img
                                    fluid={
                                        contentRowImage.localFile
                                            .childImageSharp.fluid
                                    }
                                />
                            </div>
                            <div className="content-container">
                                <div className="inner-wrap">
                                    <h3>{contentRowTitle}</h3>
                                    <p>{contentRowDescription}</p>
                                </div>
                            </div>
                        </Wrapper>
                    );
                })}
        </CollectionContentRowsContainer>
    );
};

export default CollectionContentRows;
